// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--81389";
export var content = "styles-module--content--956db";
export var head = "styles-module--head--cde6e";
export var header = "styles-module--header--53b84";
export var pulse = "styles-module--pulse--ab4d0";
export var subtitle = "styles-module--subtitle--f015e";
export var title = "styles-module--title--ae255";